import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "../../lib/api";

// Section Avis clients réutilisable (v1.5) — placements : accueil | coordination | realisations.
// Injecte le Schema.org AggregateRating dans le <head> pour le SEO.
export const ReviewsSection = ({ placement, title = "Ce que disent nos mariés" }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reviews", { params: { placement } }).then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, [placement]);

  useEffect(() => {
    if (!data?.aggregate) return;
    const id = `aggregate-rating-${placement}`;
    if (document.getElementById(id)) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.textContent = JSON.stringify(data.aggregate);
    document.head.appendChild(script);
    return () => document.getElementById(id)?.remove();
  }, [data, placement]);

  if (!data || data.items.length === 0) return null;

  return (
    <section className="bg-sage-light py-16 md:py-20" data-testid={`reviews-section-${placement}`}>
      <div className="container-ae">
        <div className="text-center">
          <p className="overline-ae">Avis vérifiés</p>
          <h2 className="mt-3 font-heading text-2xl text-deepgreen sm:text-3xl">{title}</h2>
          {data.aggregate && (
            <p className="mt-2 flex items-center justify-center gap-2 text-sm text-muted-foreground" data-testid="reviews-aggregate">
              <span className="flex gap-0.5">{Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className={`h-4 w-4 ${i < Math.round(data.aggregate.aggregateRating.ratingValue) ? "fill-gold text-gold" : "text-deepgreen/20"}`} />
              ))}</span>
              {data.aggregate.aggregateRating.ratingValue}/5 — {data.aggregate.aggregateRating.reviewCount} avis
            </p>
          )}
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {data.items.slice(0, 6).map((r) => (
            <figure key={r.id} className="card-ae p-6" data-testid={`review-card-${r.id}`}>
              <Quote className="h-6 w-6 text-sage" aria-hidden />
              <blockquote className="mt-3 text-sm italic leading-relaxed text-foreground/80">« {r.text} »</blockquote>
              <div className="mt-3 flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className={`h-4 w-4 ${i < r.rating ? "fill-gold text-gold" : "text-deepgreen/20"}`} />
                ))}
              </div>
              <figcaption className="mt-2 text-xs font-semibold uppercase tracking-wider text-deepgreen">
                {r.author}
                <span className="ml-2 font-normal normal-case text-muted-foreground">— {r.source}</span>
              </figcaption>
              {r.event_context && <p className="mt-1 text-[11px] text-muted-foreground">{r.event_context}</p>}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
